// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import flow from 'lodash/flow';
import { withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import LinkCell from '@atlassian/jira-common-directory-v2/src/components/link-cell';
import { TransitionComponent } from '@atlassian/jira-common-directory-v2/src/components/transition-component';
import { connect } from '@atlassian/jira-react-redux';
import type { EntityCellProps } from '../../../../model';
import { getName, getViewUrl } from '../../../../state/selectors/filters';
import type { State } from '../../../../state/types';

type Props = JSX.LibraryManagedAttributes<typeof LinkCell, ComponentProps<typeof LinkCell>>;

const TitleLink = ({ caption, href, onClick }: Props) => (
	<TransitionComponent href={href} onClick={onClick}>
		{(props) => <LinkCell {...props} caption={caption} />}
	</TransitionComponent>
);

const mapStateToProps = () => (state: State, ownProps: EntityCellProps) => ({
	caption: getName(state, ownProps.id),
	href: getViewUrl(state, ownProps.id),
});

export default flow(
	withFireUiAnalytics({
		onClick: 'filter',
	}),
	connect(mapStateToProps, {}),
)(TitleLink);
